import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import InterviewReviewPage from '../../features/interview/components/InterviewReviewPage';

const InterviewReviewPageRoute = () => (
  <ProtectedRoute requiresAuth={true}>
    <InterviewReviewPage />
  </ProtectedRoute>
);

export default InterviewReviewPageRoute;
